export default "__VITE_ASSET__K5crQxI7__"